<nav class="inm-topbar fixed-top">
  <a class="inm-topbar__brand" routerLink="/" aria-label="Inicio · Inmersión Colombia">
    <img [src]="image" alt="Inmersión Colombia" />
  </a>

  <div class="inm-topbar__search">
    <app-header-search />
  </div>

  <div class="inm-topbar__nav">
    <app-main-navigation [navigation]="navigation()" />
  </div>

  <div class="inm-topbar__actions">
    <app-checkout-popover />

    <button
      type="button"
      class="inm-topbar__icon-button"
      aria-controls="mobileNavSheet"
      [attr.aria-expanded]="menuOpen()"
      aria-label="Abrir menú"
      (click)="openMenu()"
    >
      <i class="fa-solid fa-bars" aria-hidden="true"></i>
    </button>
  </div>
</nav>

<!--
  En móvil el menú vive dentro de un bottom sheet en lugar del panel deslizante
  anterior, para alinearlo con el resto de superficies del rediseño.
-->
<app-bottom-sheet
  id="mobileNavSheet"
  title="Menú"
  description="Navega por Inmersión Colombia"
  [(open)]="menuOpen"
>
  <app-main-navigation
    class="inm-topbar__sheet-nav"
    [navigation]="navigation()"
    (closeNavigation)="menuOpen.set(false)"
  />
</app-bottom-sheet>
